<template>
  <v-layout
    column
    :class="css"
  >
    <span
      v-if="field.data.label && !noLabel"
      class="field-label"
    >{{
      field.data.label
    }}</span>
    <v-menu
      v-model="colorfieldShowPickerDialog"
      :close-on-content-click="false"
      :max-width="$vuetify.breakpoint.xs ? $vuetify.breakpoint.width - 48 : 480"
      offset-y
    >
      <v-btn
        v-if="smallInlineButton"
        slot="activator"
        icon
        class="mx-0 mt-2 grey--text text--darken-1"
      >
        <v-icon
          style="
            position: absolute;
            clip-path: polygon(0 0, 100% 0, 100% 75%, 0 75%);
          "
        >
          {{ inlineButtonIcon }}
        </v-icon>
        <v-icon
          :color="value"
          :class="{
            'transparency-checker-background small': value === 'transparent',
          }"
          style="
            position: absolute;
            clip-path: polygon(0% 75%, 100% 75%, 100% 100%, 0% 100%);
          "
        >
          format_color_fill
        </v-icon>
      </v-btn>
      <v-layout
        v-else
        slot="activator"
        align-center
        justify-center
      >
        <div
          :class="{'transparency-checker-background': value === 'transparent'}"
        >
          <div
            class="colorfield-input clickable bordered--subtle"
            :style="{background: value !== 'transparent' ? value : 'inherit'}"
            data-cy="overlay-data-colorfield"
          />
        </div>
      </v-layout>
      <v-card>
        <v-card-text>
          <color-picker
            :key="renderKey + colorfieldShowPickerDialog"
            :color="value"
            show-color-palette
            :color-palette="colorPalette"
            @changed="(color) => onColorChanged(color)"
            @close="colorfieldShowPickerDialog = false"
          />
        </v-card-text>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import {OverlayOptionsField} from '@/mixins/overlayOptions.js';

import ColorPicker from '@/components/ColorPicker';

export default {
  components: {
    ColorPicker,
  },
  props: {
    field: {
      type: OverlayOptionsField,
      required: true,
    },
    renderKey: {
      type: [String, Number],
      required: true,
    },
    colorPalette: {
      type: Array,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'overlay-options-field-bg',
    },
    marginClass: {
      type: String,
      default: 'mb-3',
    },
    smallInlineButton: {
      type: Boolean,
      default: false,
    },
    inlineButtonIcon: {
      type: String,
      default: 'format_color_fill',
    },
  },
  data() {
    return {
      colorfieldShowPickerDialog: false,
    };
  },
  computed: {
    css() {
      const classNames = [];
      if (this.backgroundClass) {
        classNames.push(this.backgroundClass);
      }
      if (this.marginClass) {
        classNames.push(this.marginClass);
      }
      if (!this.smallInlineButton) {
        classNames.push('pa-3');
      }
      return classNames;
    },
  },
  methods: {
    onColorChanged(value) {
      this.$emit('update:value', value);
    },
  },
};
</script>

<style scoped>
.field-label {
  font-size: 12px;
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.54);
}

.colorfield-input {
  min-width: 81px;
  height: 81px;
}
</style>



// WEBPACK FOOTER //
// src/components/OverlayDataColorField.vue